import React, { useEffect } from 'react';
import ModalVideo from 'react-modal-video';

function AboutUsArea() {
  const [openModal, setOpenModal] = React.useState(false);
  return (
    <section className="about-us-area pt-90 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 order-0 order-lg-2">
            <div className="about-img">
              <img src="assets/img/images/about_us_img.png" alt="" />
              {/* <Link to="/https://www.youtube.com/watch?v=_LTiEXMc5J0" className="popup-video">
                    <img src="assets/img/icon/play_btn.png" alt="" />
                    </Link> */}
              <ModalVideo
                channel="custom"
                isOpen={openModal}
                url='assets/videos/mainVideo.mp4'
                onClose={() => setOpenModal(false)}
                
              />
              <img
                src="assets/img/icon/play_btn.png"
                alt=""
                onClick={() => {
                  setOpenModal(true);
                }}
                className="popup-video"
                width={'40px'}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="section-title title-style-two mb-45">
              <span>Safe Moon Defenders</span>
              <h2 className="text-secondary">
                Noob Dia <span>Story</span> Tournament
              </h2>
            </div>
            <div className="about-content">
              <p>
                In the year 2332, humanity had established colonies on several
                planets in the solar system. Life was good, and the colonies
                thrived under the protection of the Safe-Moon Defenders.Yet,
                this peace was shattered when an unknown alien race emerged from
                a wormhole and began attacking the colonies.
              </p>
              <div className="about-btn">
                <a href="/#/about-story" className="btn">
                  READ MORE
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUsArea;
